import VueAwesomeSwiper from 'vue-awesome-swiper';


import Vue from 'vue'
import App from './App.vue'
import VueScrollactive from 'vue-scrollactive';
import vClickOutside from 'v-click-outside'
import {VContainer} from '@/components/ui';
import createI18n from './i18n/i18n';
import _ from 'lodash';
Vue.config.productionTip = false
Vue.use(vClickOutside)
Vue.use(VueScrollactive);
Vue.use(VueAwesomeSwiper);
Vue.component('v-container', VContainer);
Vue.prototype.$c = function(term: any) {
    try {
        // @ts-ignore
        return _.get(window.RWLCOM.content.services, term) ?? term;
    } catch (e) {
        return term;
    }
}
const content = (() => {
    const r = require.context('../translations', true, /\.json$/);
    const messages = r
        .keys()
        .reduce((acc: any, current: any) => {
            const match = /\.\/(\w{2})\.json/gm.exec(current);
            if (match) {
                const language = match[1];
                acc[language] = r(current);
            }

            return acc;
        }, {} as Record<string, any>);

    return messages;
})()

let defaultLanguage;
try {
    // @ts-ignore
    defaultLanguage = window.RWLCOM.settings.services.language
} catch (e) {
    defaultLanguage = 'en';
}
const i18n = createI18n(Vue,
    {
      availableLanguages: ['pl', 'en', 'sv', 'lt', 'cs', 'it'],
      defaultLanguage,
    },
    content,
);
new Vue({
    i18n,
  render: h => h(App),
}).$mount('#app')
